export default "__VITE_ASSET__DbRDlmkU__"